// extracted by mini-css-extract-plugin
export default {"login-header-button":"UserMenu_login-header-button__f+DiO","button-link":"UserMenu_button-link__SyEoy"};